import { Component, OnInit } from "@angular/core";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DatePipe } from "@angular/common";
import { SelfService } from "src/app/bpg-self-services/self-services.service.ts";
import { Router } from "@angular/router";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { BpgCommonService } from "src/app/bpg-common/services/bpg-common.service";

@Component({
  selector: "app-hoshin",
  templateUrl: "./hoshin.component.html",
  styleUrls: ["./hoshin.component.css"],
})
export class HoshinComponent implements OnInit {
  //common
  adminId = localStorage.getItem("adminId");
  loginData: any = JSON.parse(localStorage.getItem("loginData"));
  userId: any = this.loginData["userId"];
  yearList: any = [];
  displayType: string;
  fiscalYear: any;
  removeToolbar: any = {
    disableNativeSpellChecker: false,
    toolbar: "Basic",
    uiColor: "#FFFFFF",
    basicEntities: false,
    fillEmptyBlocks: false,
    removeButtons:
      "Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat",
    height: "130px",
    Backgroundcolor: "black !important",
  };
  siteName: any;
  bpgName: any;
  chapterId: any;
  method: string;
  param: string;
  msg: string;
  overallStatus: string;
  //new initiative
  affinityGoals = "";
  chapterGoals = "";
  bpgInitiative: any;
  businessDrivers: any;
  frequency: any;
  proposedBudget: any;
  approvedBudget: any;
  leadId1: any;
  leadId2: any;
  additionalFunding: any;
  additionalFundingSource: any;
  addToCalendar = true;
  actionPlan: any;
  why: any;
  plan: any;
  how: any;
  locationWhere: any;
  what: any;
  frequencyList: any = [];
  maxDate: any;
  minDate: any;
  initiativeList: any = [];
  printInitiativeHoshinList: any[] = [];
  printTimestamp: string = '';
  kpiList: any = [];
  selectedKpiList: any = [];
  estimatedTiming: any;
  selectedMonthYear: any;
  prevFy: any;
  prevFyShort: any;
  prevAffinityGoals = "";
  prevchapterGoals = "";
  prevInitiativeList: any = [];
  hoshinId: any;
  addCustomKpi = false;
  errorMsg = "";
  errorMsgForMissingKpi = "";
  selectedChapter = false;
  bpgList: any = [];
  siteList: any = [];
  siteId: any = null;
  bpgId: any = null;
  //review details

  highlights = "";
  challenges = "";
  hoshinList: any = [];
  hoshinBase: any;
  isKpiReviewSelected = true;
  isOverallReviewSelected = false;
  isDetailsClicked = true;
  isKpiClicked = false;
  isGoalsSelected = false;
  isInitiativesSelected = true;
  isAddNewInitiative = false;
  kpiName: any;
  kpiCount: any;
  isViewClicked = false;
  newkpiCount = 0;
  selectedKpi: string;
  isEditKpi: boolean;
  isNextYearPlanCompleted: boolean;
  hoshinSuccess: boolean;
  userList: any;
  kpiSuccess: boolean;
  kpiNameEditable = false;
  kpiExist = false;
  kpi: any;
  isCloned: boolean;
  isAddNewInitiativeButtonSelected: boolean;
  cloneDisable = false;
  isAddNewInitiativeSelected: boolean;
  initiativeName: any;
  evaluation: any;

  //approval
  approveOrRejectHoshin = false;
  approvedAmount: number;
  hoshinApproveClicked = false;
  approveRejectComment = "";
  hoshinApproved = false;
  hoshinRejected = false;
  hoshinSubmitted = false;
  readOnly = false;
  isSuperAdminApproved: any;
  isAllHoshinsApproved = false;
  resetHoshinEvaluation: any = [];
  totalProposedBudget: any;
  totalApprovedBudget: any = "-";
  adminsEdit = false;
  claimedAmount: any;
  printClicked: boolean;
  userAndRoleIdDTO: { userId: any; roleId: string };
  pastHoshinList: any = [];
  isbpgAdmin: boolean;
  isbpgLeadAdmin: boolean;
  isNaacAdmin = false;
  isNaacViewOnly = false;
  superAdminApprovalComments: any;
  newApprovedAmountGreater: boolean;
  errorMsgForMissingMandatoryFields = "";
  hoshinSubmit: boolean;
  isAdditionalFundingSelected = false;
  isAnyInitiativeRejected = false;
  showDeclineAllModal = false;
  declineAllComment = '';
  overallHoshinApproved = false;
  overallHoshinRejected = false;
  submitButtonClicked = false;
  kpiReviewMissingFields = "";
  overallReviewMissingFields = "";
  reviewSubmittedYear: any;
  saveKPIReviewDTO: { hoshinId: any; evaluation: string };
  goalsReview: any;
  enableSaveInitiativeButton = false;
  singleChapterAdmin = false;
  printHoshinsList: any = [];
  currentHoshin: any = [];
  kpiReviewSaved: boolean;
  dataTargetConstant = "data-target";
  dataToggleConstant = "data-toggle";
  fiscalYearString: any;
  currentFiscalYear: any;
  //reflection
  disabledReflection = true;
  refIsActive = true;
  fy: any;
  currentYearDetails: any;
  maxLength = 2000;
  reflectionChangesDisabled = true;
  reflectionStatusforPastFY = false;
  pendingReflectionYear: number;
  prevHoshinStatus = "";
  showReflectionPopup = false;
  additionalAdminComments = "";
  autoRedirectTimeout = null;

  constructor(
    private readonly hoshinService: HoshinBudgetService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly datepipe: DatePipe,
    private readonly userService: SelfService,
    private readonly router: Router,
    private readonly bpgCommonService: BpgCommonService
  ) { }

  isCurrentHoshinIncomplete = true;

  kpiDisable() {
    if(this.fiscalYear <= 2026){
      this.why = " ";
      this.plan = " ";
      this.how = " ";
      this.locationWhere = " ";
      this.what = " ";
    }
    if (
      this.bpgInitiative &&
      this.businessDrivers &&
      this.proposedBudget >= 0 &&
      this.actionPlan &&
      this.why &&
      this.plan &&
      this.how &&
      this.locationWhere &&
      this.what &&
      this.frequency &&
      this.hoshinId !== 0
    ) {
      if (this.frequency.toLowerCase() === "once") {
        if (this.estimatedTiming) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }
  ngOnInit() {
    this.logUserAction();
    this.userAndRoleIdDTO = {
      userId: this.loginData["userId"],
      roleId: localStorage.getItem("adminId"),
    };

    if (
      localStorage.getItem("loginData") === null ||
      localStorage.getItem("loginData") === undefined
    ) {
      this.router.navigate(["/log-out"]);
    }

    if (localStorage.getItem("logOutFlag") === "true") {
      this.router.navigate(["/log-out"]);
    }
    if (localStorage.getItem("isbpgAdmin") === "true") {
      this.isbpgAdmin = true;
    }
    if (localStorage.getItem("isbpgLeadAdmin") === "true") {
      this.isbpgLeadAdmin = true;
    }
    if (localStorage.getItem("isNaacAdmin") === "true") {
      this.isNaacAdmin = true;
    }
    this.isNaacAdmin = this.isNaacUser();
    if (
      this.adminId === "1" ||
      this.adminId === "2" ||
      this.adminId === "3" ||
      this.isbpgLeadAdmin ||
      this.isbpgAdmin ||
      (this.isbpgAdmin && this.isbpgLeadAdmin && this.isNaacAdmin) ||
      this.adminId === "4" ||
      this.isNaacAdmin
    ) {
      this.siteId = sessionStorage.getItem("siteIdForHoshin");
      this.bpgId = sessionStorage.getItem("bpgIdForHoshin");
      this.fy = sessionStorage.getItem("fiscalYear");
      this.fetchData();
    }

    this.frequencyList = [
      { type: "Once" },
      { type: "Monthly" },
      { type: "Quarterly" },
    ];

    if (localStorage.getItem("isMultiChapterAdmin") !== "true") {
      this.singleChapterAdmin = true;
    }
  }

  get businessDriversList() {
    if (this.fiscalYear <= 2026) {
      return [
        { type: "Team Member Engagement" },
        { type: "Community Engagement" },
        { type: "Workforce Readiness" },
        { type: "Business Support" },
      ];
    }
    return [
      { type: "Team Member Engagement" },
      { type: "Community Engagement" },
      { type: "Career Readiness Support" },
    ];
  } 

  fetchData() {
    this.resetAllData();
    this.fetchPrintHoshins();
  }
  fetchPrintHoshins() {
    this.spinner.show();
    const hoshinData = {
      userId: this.userId,
      adminId: this.adminId,
      bpgId: this.bpgId,
      siteId: this.siteId,
    };

    this.hoshinService.getPastHoshins(hoshinData).subscribe((res) => {
      if (res != null && res !== undefined) {
        if (res.pastHoshins.length > 0) {
          this.pastHoshinList = res.pastHoshins;
        }
        if (res.currentHoshin != null) {
          this.currentHoshin.push(res.currentHoshin);
          this.printHoshinsList = [
            ...this.printHoshinsList,
            ...this.currentHoshin,
          ];
        }
        if (this.pastHoshinList.length > 0) {
          this.pastHoshinList[0].show = true;
          this.printHoshinsList = [
            ...this.printHoshinsList,
            ...this.pastHoshinList,
          ];
        }
        if (this.adminId === "4" || this.isNaacAdmin) {
          this.selectedChapter = true;
        }
      }
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
    });
  }

  selectHoshin(budgetId) {
    this.spinner.show();
    for (const printHoshin of this.printHoshinsList) {
      if (printHoshin.budgetId === budgetId) {
        printHoshin.show = true;
      } else {
        printHoshin.show = false;
      }
    }
    setTimeout(() => {
      this.printHoshin();
    }, 2000);
  }
  resetAllData() {
    //new initiative
    this.affinityGoals = "";
    this.chapterGoals = "";
    this.bpgInitiative = null;
    this.businessDrivers = null;
    this.frequency = null;
    this.proposedBudget = null;
    this.approvedBudget = null;
    this.leadId1 = null;
    this.leadId2 = null;
    this.additionalFunding = null;
    this.additionalFundingSource = null;
    this.actionPlan = null;
    this.why = null;
    this.plan = null;
    this.how = null;
    this.locationWhere = null;
    this.what = null;
    this.initiativeList = [];
    this.estimatedTiming = null;
    this.selectedMonthYear = null;
    this.prevFy = null;
    this.prevFyShort = null;
    this.prevAffinityGoals = "";
    this.prevchapterGoals = "";
    this.prevInitiativeList = [];
    this.hoshinId = null;
    this.addCustomKpi = false;
    this.addToCalendar = true;
    this.errorMsg = "";
    this.errorMsgForMissingKpi = "";
    this.isAdditionalFundingSelected = false;

    this.highlights = "";
    this.challenges = "";
    this.hoshinList = [];
    this.hoshinBase = null;

    this.isKpiReviewSelected = true;
    this.isOverallReviewSelected = false;
    this.isDetailsClicked = true;
    this.isKpiClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isAddNewInitiative = false;
    this.kpiName = null;
    this.kpiCount = null;
    this.isViewClicked = false;
    this.newkpiCount = 0;
    this.selectedKpi = "";
    this.isEditKpi = false;
    this.isNextYearPlanCompleted = false;
    this.hoshinSuccess = false;
    this.userList = [];
    this.kpiSuccess = false;
    this.kpiNameEditable = false;
    this.kpiExist = false;
    this.kpi = null;
    this.isCloned = false;
    this.isAddNewInitiativeButtonSelected = false;
    this.cloneDisable = false;
    this.isAddNewInitiativeSelected = false;
    this.initiativeName = null;

    this.approveOrRejectHoshin = false;
    this.approvedAmount = null;
    this.hoshinApproveClicked = false;
    this.approveRejectComment = "";
    this.hoshinApproved = false;
    this.hoshinRejected = false;
    this.hoshinSubmitted = false;
    this.readOnly = false;
    this.isSuperAdminApproved = false;
    this.isAllHoshinsApproved = false;
    this.isAnyInitiativeRejected = false;
    this.resetHoshinEvaluation = [];
    this.totalProposedBudget = null;
    this.totalApprovedBudget = null;
    this.adminsEdit = false;
    this.claimedAmount = null;
    this.pastHoshinList = [];
    this.printHoshinsList = [];
    this.currentHoshin = [];
    this.reflectionStatusforPastFY = false;
    this.getYears();
  }

  changeIsActive(data) {
    this.refIsActive = true;
    this.yearList.map((res) => {
      if (res === data) {
        res.isActive = true;
      } else {
        res.isActive = false;
      }
    });
    this.getHoshinDetails(data.year, data.type);
    this.kpiName = null;
    this.selectedKpi = null;
    this.kpi = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.isKpiClicked = false;
    this.isDetailsClicked = true;
    this.cloneDisable = false;
    this.isAddNewInitiativeSelected = false;
  }

  getYears(type?: string) {
    this.selectedChapter = true;
    const userData = {
      userId: this.userId,
      adminId: this.adminId,
      siteId: this.siteId,
      bpgId: this.bpgId,
      fiscalYear: Number(this.fy),
    };
    this.hoshinService.getHoshinYears(userData).subscribe((res) => {
      this.spinner.show();
      if (res != null && res !== undefined) {
        this.yearList = res;
        if (type === "saveReview") {
          this.yearList.map((res) => {
            if (res.year === this.fiscalYear && res.type === "reflection") {
              res.isActive = true;
            } else {
              res.isActive = false;
            }
          });
          this.getHoshinDetails(this.fiscalYear, "reflection");
        } else {
          this.yearList.map((res) => {
            res.isActive = false;
          });
          //hoshin default screen start view
          if (
            this.yearList.length > 1 &&
            this.yearList[1].enabled === true &&
            this.reflectionStatusforPastFY
          ) {
            this.getHoshinDetails(this.yearList[1].year, this.yearList[1].type);
            this.yearList[1].isActive = true;
          } else {
            this.getHoshinDetails(this.yearList[0].year, this.yearList[0].type); ///entry point : normal case
            this.yearList[0].isActive = true;
          }
        }
      }
    });
  }
  getLeadDetails() {
    const landingDto = {
      filter: {
        chapterId: this.chapterId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 0,
      sortDirection: "ASC",
      sortProperty: "",
      uid: "",
    };
    this.userService.getUserDropDown(landingDto).subscribe((data) => {
      this.userList = data;
      this.userList.map((i) => {
        i.userFirstName = `${i.userFirstName} ${i.userLastName}`;
        return i;
      });
    });
  }
  toggleCheckbox(e: MatCheckboxChange) {
    if (e.checked) {
      this.hoshinApproveClicked = true;
    } else {
      this.hoshinApproveClicked = false;
    }
  }
  getHoshinDetails(fiscalYear, type, flag?: string): Promise<void> {
    this.spinner.show();
    this.submitButtonClicked = false;
    this.hoshinSuccess = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isEditKpi = false;
    this.displayType = type;
    this.isAddNewInitiative = false;
    this.kpiSuccess = false;
    this.approveOrRejectHoshin = false;
    this.newApprovedAmountGreater = false;
    this.errorMsg = "";
    const hoshinData = {
      userId: this.userId,
      adminId: this.adminId,
      fiscalYear: fiscalYear,
      type: type,
      siteId: this.siteId,
      bpgId: this.bpgId,
    };
    this.fiscalYear = fiscalYear;
    this.fiscalYearString = (this.fiscalYear - 1).toString();
    if (type === "plan") {
      this.prevFy = Number(fiscalYear) - 1;
      this.prevFyShort = String(this.prevFy).substring(2, 5);
    }
    // adjust minDate and maxDate accordingly to fiscalYear
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    // If the month is before April, the fiscal year is the previous year
    if (month < 4) {
      this.currentFiscalYear = year;
    } else {
      this.currentFiscalYear = year + 1;
    }
    if (this.currentFiscalYear < fiscalYear) {
      this.minDate = new Date(`${this.fiscalYear - 1}/04/01`);
      this.maxDate = new Date(this.fiscalYear + "/03/30");
    } else {
      this.minDate = new Date(`${this.fiscalYear - 1}/${month.toString()}/01`);
      this.maxDate = new Date(this.fiscalYear + "/03/30");
    }
    // Deadline extension: Allowing FY2026 reflections to be editable until July 1, 2026.
    const exceptionDeadline = new Date('2026-07-01');
    const today = new Date();
    const isDeadlineExtented = fiscalYear === 2026 && today < exceptionDeadline;

    if (fiscalYear === this.currentFiscalYear || isDeadlineExtented) {
      this.reflectionChangesDisabled = false;
    } else {
      this.reflectionChangesDisabled = true;
    }
    return new Promise<void>((resolve) => {
      this.hoshinService.getHoshinForSingleUser(hoshinData).subscribe((res) => {
        if (res != null && res !== undefined) {
          this.spinner.hide();
          this.reflectionStatusforPastFY =
            res.reflectionStatusforAllApprovedHoshin;
          this.siteName = res.siteName;
          this.bpgName = res.bpgName;
          this.chapterId = res.chapterId;
          this.overallStatus = res.overallStatus;
          this.isAllHoshinsApproved = res.isAllHoshinsApproved;
          this.isAnyInitiativeRejected = res.isAnyInitiativeRejected;
          this.totalProposedBudget = res.totalProposedBudget;
          this.totalApprovedBudget = res.totalApprovedBudget;
          this.challenges = res.currentYearDetails.challenges;
          this.highlights = res.currentYearDetails.highlights;
          this.additionalAdminComments = res.currentYearDetails.additionalComments;
          this.prevHoshinStatus = res.prevYearDetails.hoshinStatus;
          if (this.overallStatus === "DRAFT" || this.overallStatus === "NEW") {
            this.readOnly = false;
          }
          if (this.overallStatus === "SUBMITTED") {
            this.readOnly = true;
          } else if (this.overallStatus === "APPROVED") {
            if (this.adminId === "1") {
              this.readOnly = false;
              this.adminsEdit = true;
            } else {
              this.readOnly = true;
              this.adminsEdit = false;
            }
          } else if (this.overallStatus === "REJECTED") {
            this.adminsEdit = false;
            this.readOnly = false;
          }
          this.isNaacViewOnly =
            this.isNaacUser() &&
            (this.overallStatus === "DRAFT" ||
              this.overallStatus === "NEW" ||
              this.overallStatus === "SUBMITTED");
          if (this.isNaacViewOnly) {
            this.readOnly = true;
            this.adminsEdit = false;
          }
          if (type === "plan") {
            if (!this.reflectionStatusforPastFY && fiscalYear > this.currentFiscalYear && this.prevHoshinStatus === "APPROVED") {
              this.pendingReflectionYear = fiscalYear - 1;
              this.msg = `The reflection for FY ${this.pendingReflectionYear} has not been completed. Please complete the reflection before proceeding with FY ${fiscalYear} planning. You will be redirected automatically in 15 seconds, or you may navigate immediately using the button below.`;
              this.showReflectionPopup = true;
              this.autoRedirectTimeout = setTimeout(() => {
                if (this.showReflectionPopup) {
                  this.showReflectionPopup = false;
                  this.confirmGoToReflection(this.pendingReflectionYear);
                }
              }, 15000);
            }
            if (res.currentYearDetails != null && res.currentYearDetails !== undefined) {
              this.chapterGoals = res.currentYearDetails["chapterGoals"];
              this.chapterGoals = new DOMParser().parseFromString(
                this.chapterGoals,
                "text/html"
              ).documentElement.textContent;
              this.affinityGoals = res.currentYearDetails["affinityGoals"];
              this.affinityGoals = new DOMParser().parseFromString(
                this.affinityGoals,
                "text/html"
              ).documentElement.textContent;
              this.initiativeList = res.currentYearDetails["initiativeList"];
              this.isAnyInitiativeRejected = this.initiativeList.some(i => i.isSuperAdminApproved === false);
              this.goalsReview = res.currentYearDetails["goalsReview"];
            }
            if (res.prevYearDetails != null && res.prevYearDetails !== undefined) {
              this.prevchapterGoals = res.prevYearDetails["chapterGoals"];
              this.prevchapterGoals = new DOMParser().parseFromString(
                this.prevchapterGoals,
                "text/html"
              ).documentElement.textContent;
              this.prevAffinityGoals = res.prevYearDetails["affinityGoals"];
              this.prevAffinityGoals = new DOMParser().parseFromString(
                this.prevAffinityGoals,
                "text/html"
              ).documentElement.textContent;
              this.prevInitiativeList = res.prevYearDetails["initiativeList"];
            }
              this.selectInitiative();
            if (this.initiativeList.length > 0) {
              const validDrivers = this.businessDriversList.map(d => d.type);
              for (const initiative of this.initiativeList) {
                if (initiative.isCloned) {
                  this.cloneDisable = true;
                }
                if (initiative.businessDrivers && !validDrivers.includes(initiative.businessDrivers)) {
                  initiative.businessDriversInvalid = true;
                }
              }
            }
            this.getLeadDetails();
            if (flag === "saveHoshin" || flag === "cancelKpi") {
              this.calculateMissingMandatoryFields();
              this.calculateMissingKpi();
            }
          }
          if (type === "reflection") {
            this.isOverallReviewSelected = true;
            this.isKpiReviewSelected = false;
            if (res.currentYearDetails != null && res.currentYearDetails !== undefined) {
              this.isNextYearPlanCompleted = res.isNextYearPlanCompleted;
              this.hoshinList = res.currentYearDetails["initiativeList"];
              if (this.hoshinList.length > 0) {
                this.isKpiReviewSelected = true;
                this.isOverallReviewSelected = false;
              }
              let c = "";
              let h = "";
              for (const i of this.hoshinList) {
                c += `${i.bpgInitiative} :
- ${(i.challenges || "").trim()}
`;

                h += `${i.bpgInitiative} :
- ${(i.highlights || "").trim()}
`;
              }
              c = c.trim();
              h = h.trim();

              this.challenges = c + "\n";
              this.highlights = h + "\n";
              this.calculateMissingFieldsInReflectionScreen();
            }
          }
        }
        resolve();
      });
    });
  }

  editHoshin(data, flag?: string) {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.isAddNewInitiativeSelected = true;
    this.isAddNewInitiative = true;
    this.initiativeName = data.bpgInitiative;
    this.bpgInitiative = data.bpgInitiative;
    this.businessDrivers = data.businessDriversInvalid ? null : data.businessDrivers;
    this.frequency = data.frequency;
    this.isAdditionalFundingSelected = data.isAdditionalFundingSelected;
    this.proposedBudget = data.proposedBudget;
    this.claimedAmount = data.claimedAmount;
    this.approvedBudget = data.superAdminApprovedBudget;
    this.leadId1 = data.leadId1;
    this.leadId2 = data.leadId2;
    this.additionalFunding = data.additionalFunding;
    this.additionalFundingSource = data.additionalFundingSource;
    this.actionPlan = data.actionPlan;    
    this.why = data.why;
    this.plan = data.plan;
    this.how = data.how;
    this.locationWhere = data.locationWhere;
    this.what = data.what;
    this.actionPlan = new DOMParser().parseFromString(
      this.actionPlan,
      "text/html"
    ).documentElement.textContent;
    this.estimatedTiming = data.estimatedTiming;
    this.hoshinId = data.hoshinId;
    this.addToCalendar = data.addToCalendar == null ? true : data.addToCalendar;
    this.selectedKpiList = data.selectedKpiList ? data.selectedKpiList : [];
    let count = 0;
    if (this.selectedKpiList.length >= 1) {
      this.selectedKpiList.map((res) => {
        if (res.isMasterKpi) {
          count++;
        }
      });
    }
    this.enableSaveInitiativeButton = count > 0;
    this.kpiList = data.kpiList;
    this.superAdminApprovalComments = data.superAdminApprovalComment;
    this.isSuperAdminApproved = data.isSuperAdminApproved;
    if (flag === "approval") {
      this.addApproverComments();
    }
  }

  saveHoshin() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.hoshinSuccess = false;
    this.newApprovedAmountGreater = false;
    let remainAmount = 0;
    const remainList = [];
    this.enableSaveInitiative();
    if (this.initiativeList.length > 0) {
      for (const initiative of this.initiativeList) {
        if (initiative.hoshinId !== this.hoshinId) {
          remainList.push(initiative);
        }
      }

      remainList.forEach((res1) => {
        remainAmount += res1.superAdminApprovedBudget;
      });
      remainAmount += this.approvedBudget;
    }

    if (this.overallStatus === "APPROVED" && this.newApprovedAmountGreater) {
      this.spinner.hide();
    } else {
      this.spinner.show();
      const iniativeData = {
        chapterId: this.chapterId,
        fiscalYear: this.fiscalYear,
        bpgInitiative: this.bpgInitiative,
        businessDrivers: this.businessDrivers,
        frequency: this.frequency,
        estimatedTiming: this.estimatedTiming,
        proposedBudget: this.proposedBudget,
        leadId1: this.leadId1,
        leadId2: this.leadId2,
        addToCalendar: this.addToCalendar,
        additionalFunding: this.additionalFunding,
        additionalFundingSource: this.additionalFundingSource,
        actionPlan: this.actionPlan,
        why: this.why,
        plan: this.plan,
        how: this.how,
        locationWhere: this.locationWhere,
        what: this.what,
        userId: this.userId,
        hoshinId: this.hoshinId,
        superAdminApprovedBudget: this.approvedBudget,
        isAdditionalFundingSelected: this.isAdditionalFundingSelected,
      };
      this.hoshinService.saveHoshinInitiative(iniativeData).subscribe((res) => {
        if (res != null && res !== undefined) {
          this.hoshinId = res.hoshinId;
          //added to update error message
          this.initiativeList.map((initiative) => {
            if (initiative.hoshinId === this.hoshinId) {
              initiative.bpgInitiative = res.bpgInitiative;
              initiative.businessDrivers = res.businessDrivers;
              initiative.businessDriversInvalid = false;
              initiative.frequency = res.frequency;
              initiative.estimatedTiming = res.estimatedTiming;
              initiative.proposedBudget = res.proposedBudget;
              initiative.leadId1 = res.leadId1;
              initiative.leadId2 = res.leadId2;
              initiative.additionalFunding = res.additionalFunding;
              initiative.additionalFundingSource = res.additionalFundingSource;
              initiative.actionPlan = res.actionPlan;
              initiative.why = res.why;
              initiative.plan = res.plan;
              initiative.how = res.how;
              initiative.locationWhere = res.locationWhere;
              initiative.what = res.what;
              initiative.addToCalendar = res.addToCalendar;
              initiative.superAdminApprovedBudget =
                res.superAdminApprovedBudget;
              initiative.isAdditionalFundingSelected =
                res.isAdditionalFundingSelected;
              if (
                res.frequency === "Once" &&
                res.estimatedTiming != null &&
                res.estimatedTiming !== ""
              ) {
                initiative.isValid = true;
              }
            }
          });
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.isDetailsClicked = false;
            this.isKpiClicked = true;
            this.approveOrRejectHoshin = false;
            this.calculateMissingKpi();
            this.calculateMissingMandatoryFields();
            this.spinner.hide();
          }, 2000);
        }
      });
    }
  }
  createBudgetId() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.spinner.show();
    this.errorMsg = "";
    const goalData = {
      chapterId: this.chapterId,
      fiscalYear: this.fiscalYear,
      chapterGoals: this.chapterGoals,
      affinityGoals: this.affinityGoals,
      goalsReview: this.goalsReview,
      createdBy: this.userId,
    };
    this.hoshinService.saveHoshinGoals(goalData).subscribe((data) => {
      if (this.overallStatus === "NEW") {
        this.overallStatus = "DRAFT";
      }
      this.saveHoshin();
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      if (data != null && data !== undefined) {
        setTimeout(() => {
          this.selectInitiative();
          this.spinner.hide();
        }, 2000);
      }
    });
  }
  toggleFundingCheckbox(e: MatCheckboxChange) {
    if (e.checked) {
      this.isAdditionalFundingSelected = true;
    } else {
      this.isAdditionalFundingSelected = false;
    }
  }
  resetHigh() {
    this.challenges = "";
    this.highlights = "";
  }

  deleteHoshin(hoshinId) {
    this.param = hoshinId;
    this.msg = "Are you sure you want to delete this initiative?";
    this.method = "deleteHoshinConfirmation";
  }
  deleteHoshinConfirmation(hoshinId) {
    if (this.isNaacViewOnly) {
      return;
    }
    this.submitButtonClicked = false;
    this.hoshinService
      .deleteHoshinInitative(this.userId, hoshinId)
      .subscribe((data) => {
        this.spinner.hide();
        if (data != null && data !== undefined) {
          this.initiativeList = this.initiativeList.filter(
            (res) => res.hoshinId !== hoshinId
          );
          this.calculateMissingKpi();
          this.calculateMissingMandatoryFields();
          let isClonedInitiativePresent = 0;
          this.initiativeList.map((res) => {
            if (res.isCloned) {
              isClonedInitiativePresent += 1;
            }
          });
          if (isClonedInitiativePresent === 0) {
            this.cloneDisable = false;
          }
        }
      });
  }
  addNewKpi(data) {
    if (this.isNaacViewOnly) {
      return;
    }
    if (data === "add") {
      let kpiAlreadyAdded = false;
      this.kpiExist = false;
      if (this.kpiNameEditable) {
        this.selectedKpiList.map((res) => {
          if (this.selectedKpi === res.kpiId) {
            this.kpiExist = true;
            kpiAlreadyAdded = true;
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            setTimeout(() => {
              this.kpiExist = false;
            }, 2000);
          }
        });
        if (!kpiAlreadyAdded) {
          this.kpiList.map((res) => {
            if (this.selectedKpi === res.kpiId) {
              res.kpiCount = this.kpiCount;
              this.selectedKpiList = [...this.selectedKpiList, ...res];
            }
          });
        }
      } else {
        this.selectedKpiList.map((res) => {
          if (this.kpiName.toLowerCase() === res.kpiName.toLowerCase()) {
            this.kpiExist = true;
          }
        });
        if (this.kpiExist) {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.kpiExist = false;
          }, 2000);
        } else {
          this.isEditKpi = false;
          this.newkpiCount += 1;
          this.selectedKpi = "newKpi" + this.newkpiCount.toString();
          const newKpi = [
            {
              kpiId: this.selectedKpi,
              kpiName: this.kpiName,
              kpiCount: this.kpiCount,
            },
          ];
          this.selectedKpiList = [...this.selectedKpiList, ...newKpi];
        }
      }
    } else {
      this.selectedKpiList.map((res) => {
        if (this.selectedKpi === res.kpiId) {
          res.kpiCount = this.kpiCount;
          res.kpiName = this.kpiName;
        }
      });
    }
    this.kpiName = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.kpiNameEditable = false;
    this.isEditKpi = false;
    this.kpi = null;
    this.enableSaveInitiative();
  }

  // check whether min to one kpis from dropdown is selected to enable save initiative button
  enableSaveInitiative() {
    let count = 0;
    if (this.selectedKpiList.length >= 1) {
      this.selectedKpiList.map((res) => {
        if (res.isMasterKpi) {
          count++;
        }
      });
    }
    if (count >= 1) {
      this.enableSaveInitiativeButton = true;
    } else {
      this.enableSaveInitiativeButton = false;
    }
  }

  manageKpi(event) {
    this.addCustomKpi = true;
    this.kpiName = event.kpiName;
    this.selectedKpi = event.kpiId;
    this.kpiNameEditable = true;
    this.kpiExist = false;
  }
  editKpi(data) {
    this.kpiList.map((res) => {
      if (data.kpiId === res.kpiId) {
        this.kpiNameEditable = true;
      }
    });
    this.addCustomKpi = true;
    this.isEditKpi = true;
    this.selectedKpi = data.kpiId;
    this.kpiName = data.kpiName;
    this.kpiCount = data.kpiCount;
  }

  manageCustomKpi() {
    this.kpiNameEditable = false;
    this.addCustomKpi = true;
    this.kpi = null;
    this.kpiName = null;
    this.kpiCount = null;
  }
  deleteKpi(data) {
    this.isEditKpi = false;
    this.kpi = null;
    if (data.isActive) {
      this.hoshinService
        .deleteHoshinKpi(this.hoshinId, data.kpiId, this.userId)
        .subscribe((res) => {
          if (res != null && res !== undefined) {
            this.selectedKpiList = this.selectedKpiList.filter(
              (res) => res.kpiId !== data.kpiId
            );
            if (this.selectedKpiList.length === 0) {
              this.initiativeList.map((response) => {
                if (response.hoshinId === this.hoshinId) {
                  response.selectedKpiList = [];
                }
              });
            }
            this.enableSaveInitiative();
          }
        });
    } else {
      this.selectedKpiList = this.selectedKpiList.filter(
        (res) => res.kpiId !== data.kpiId
      );
      if (this.selectedKpiList.length === 0) {
        this.initiativeList.map((response) => {
          if (response.hoshinId === this.hoshinId) {
            response.selectedKpiList = [];
          }
        });
      }
    }
  }
  saveKpi() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.spinner.show();
    this.selectedKpiList.map((res) => {
      if (
        (res.isMasterKpi === null ||
          res.isMasterKpi === undefined ||
          res.isMasterKpi === "") &&
        (res.isActive === null ||
          res.isActive === undefined ||
          res.isActive === "")
      ) {
        res.kpiId = 0;
      }
    });

    let initiativeEvaluation: {
      challenges: any;
      highlights: any;
      evaluation: any;
    };
    for (const d of this.initiativeList) {
      if (d.hoshinId === this.hoshinId) {
        initiativeEvaluation = {
          challenges: d.challenges || "",
          highlights: d.highlights || "",
          evaluation: d.evaluation || "",
        };
      }
    }

    const kpiData = {
      hoshinId: this.hoshinId,
      selectedKpiList: this.selectedKpiList,
      initiativeEvaluation: "",
      highlights: "",
      challenges: "",
      userId: this.userId,
      fiscalYear: this.fiscalYear,
      chapterId: this.chapterId,
    };
    if (this.isSuperAdminApproved) {
      kpiData.initiativeEvaluation = initiativeEvaluation.evaluation;
      kpiData.highlights = (initiativeEvaluation.highlights || '').trim();
      kpiData.challenges = (initiativeEvaluation.challenges || '').trim();
    }
    this.hoshinService.saveHoshinKpi(kpiData).subscribe((res) => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.kpiSuccess = true;
        this.kpi = null;
        const hoshinId = res.hoshinId;
        this.initiativeList.map((response) => {
          if (response.hoshinId === hoshinId) {
            response.selectedKpiList = res.selectedKpiList;
          }
        });

        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.kpiSuccess = false;
          // to update all error messages
          if (this.yearList.length > 1 && this.isAllHoshinsApproved) {
            this.getHoshinDetails(this.fiscalYear, "reflection");
            this.yearList[0].isActive = true;
            this.yearList[1].isActive = false;
          } else {
            this.getHoshinDetails(this.fiscalYear, "plan", "saveHoshin");
            if (this.yearList.length > 1) {
              this.yearList[0].isActive = false;
              this.yearList[1].isActive = true;
            }
            this.calculateMissingKpi();
            this.calculateMissingMandatoryFields();
            this.errorMsg = "";
            this.isGoalsSelected = false;
            this.isInitiativesSelected = true;
            this.isKpiClicked = false;
            this.isDetailsClicked = true;
            this.isAddNewInitiativeSelected = false;
          }
        }, 2000);
      }
    });
  }

  selectGoals() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = true;
    this.isInitiativesSelected = false;
    this.newApprovedAmountGreater = false;
    this.errorMsgForMissingKpi = "";
  }
  selectInitiative() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.errorMsg = "";
    this.calculateMissingKpi();
    this.calculateMissingMandatoryFields();
  }
  selectGoalsReview() {
    this.submitButtonClicked = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.newApprovedAmountGreater = false;
    this.errorMsgForMissingKpi = "";
  }
  copyData(data) {
    if (this.isNaacViewOnly) {
      return;
    }
    if (data === "iniative") {
      this.spinner.show();
      this.submitButtonClicked = false;
      this.isGoalsSelected = false;
      this.isInitiativesSelected = true;
      this.isCloned = false;
      this.isAddNewInitiativeButtonSelected = true;
      const cloneData = {
        initiativeList: [],
        userId: this.userId,
        fiscalYear: Number(this.fiscalYear) - 1,
        chapterId: this.chapterId,
      };
      this.hoshinService.cloneHoshins(cloneData).subscribe((res) => {
        this.spinner.hide();
        if (res != null && res !== undefined) {
          this.cloneDisable = true;
          this.overallStatus = "DRAFT";
          this.prevInitiativeList = res.initiativeList
            ? res.initiativeList
            : [];
          const validDrivers = this.businessDriversList.map(d => d.type);
          for (const pre of this.prevInitiativeList) {
            pre.isCloned = true;
            if (pre.businessDrivers && !validDrivers.includes(pre.businessDrivers)) {
              pre.businessDriversInvalid = true;
            }
          }
          this.initiativeList = [
            ...this.initiativeList,
            ...this.prevInitiativeList,
          ];
          this.calculateMissingKpi();
          this.calculateMissingMandatoryFields();
          setTimeout(() => {
            this.isCloned = true;
          }, 1000);
        }
      });
    }
  }
  addNewInitiative() {
    this.submitButtonClicked = false;
    this.initiativeName = "New Initiative";
    this.isGoalsSelected = false;
    this.isInitiativesSelected = false;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.resetHoshinInitiative();
    this.isAddNewInitiative = true;
    this.kpiSuccess = false;
    this.hoshinId = 0;
    this.isSuperAdminApproved = null;
  }

  resetHoshinInitiative() {
    this.newApprovedAmountGreater = false;
    this.bpgInitiative = "";
    this.frequency = null;
    this.proposedBudget = null;
    this.leadId1 = null;
    this.leadId2 = null;
    this.additionalFunding = null;
    this.additionalFundingSource = null;
    this.actionPlan = null;
    this.why = null;
    this.plan = null;
    this.how = null;
    this.locationWhere = null;
    this.what = null;
    this.estimatedTiming = null;
    this.selectedKpiList = [];
    this.kpiList = [];
    this.businessDrivers = null;
    this.isAdditionalFundingSelected = false;
    this.approvedBudget = null;
    this.addToCalendar = true;
  }
  resetKpi(data?: string) {
    if (data === "cancelKpi") {
      this.getHoshinDetails(this.fiscalYear, "plan", data);
    }
    this.newApprovedAmountGreater = false;
    this.isAddNewInitiativeSelected = false;
    this.isGoalsSelected = false;
    this.isInitiativesSelected = true;
    this.isCloned = true;
    this.isAddNewInitiativeButtonSelected = true;
    this.isAddNewInitiative = false;
    this.kpiName = null;
    this.selectedKpi = null;
    this.kpi = null;
    this.kpiCount = null;
    this.addCustomKpi = false;
    this.isKpiClicked = false;
    this.isDetailsClicked = true;
    this.hoshinApproved = false;
    this.hoshinRejected = false;
    this.approveOrRejectHoshin = false;
  }
  detailsClick() {
    this.isDetailsClicked = true;
    this.isKpiClicked = false;
    this.approveOrRejectHoshin = false;
  }
  kpiClick() {
    this.isDetailsClicked = false;
    this.isKpiClicked = true;
    this.approveOrRejectHoshin = false;
    this.enableSaveInitiative();
  }
  approveOrReject(type) {
    this.method = "approveOrRejectConfirmation";
    this.param = type;
    if (type === "APPROVED") {
      this.msg = "Are you sure you want to approve this Annual Plan?";
    } else {
      this.msg = "Are you sure you want to decline this Annual Plan?";
    }
  }

  approveOrRejectConfirmation(type) {
    if (this.isNaacViewOnly) {
      return;
    }
    this.spinner.show();
    const submitData = {
      userId: this.userId,
      overallStatus: type,
      chapterId: this.chapterId,
      fiscalYear: this.fiscalYear,
      type: "overall",
    };
    this.hoshinService.approveorRejectHoshin(submitData).subscribe((res) => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.overallStatus = res.overallStatus;
        if (this.overallStatus === "APPROVED") {
          this.hoshinSubmitted = true;
          this.adminsEdit = true;
          this.readOnly = false;
          this.overallHoshinApproved = true;
        } else {
          this.hoshinSubmitted = false;
          this.adminsEdit = false;
          this.readOnly = false;
          this.overallHoshinRejected = true;
        }
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.overallHoshinApproved = false;
          this.overallHoshinRejected = false;
          this.getHoshinDetails(this.fiscalYear, "plan");
        }, 2000);
      }
    });
  }
  addApproverComments() {
    this.isDetailsClicked = true;
    this.isKpiClicked = true;
    this.approveOrRejectHoshin = true;
    this.hoshinApproveClicked = false;
    this.approvedAmount = null;

    this.approveRejectComment = "";
    this.initiativeList.map((response) => {
      if (response.hoshinId === this.hoshinId) {
        if (response.isSuperAdminApproved) {
          this.hoshinApproveClicked = response.isSuperAdminApproved;
          this.isSuperAdminApproved = response.isSuperAdminApproved;
          this.approveRejectComment = response.superAdminApprovalComment
            ? response.superAdminApprovalComment
            : "";
          this.approvedAmount = response.superAdminApprovedBudget
            ? response.superAdminApprovedBudget
            : null;
        } else {
          this.isSuperAdminApproved = false;
          this.approveRejectComment = response.superAdminApprovalComment
            ? response.superAdminApprovalComment
            : "";
        }
      }
    });
  }
  selectKPIsReview() {
    this.submitButtonClicked = false;
    this.isKpiReviewSelected = true;
    this.isOverallReviewSelected = false;
  }
  selectOverallReview() {
    this.submitButtonClicked = false;
    this.isKpiReviewSelected = false;
    this.isOverallReviewSelected = true;
    this.errorMsg = "";
  }

  submitApproval(msg) {
    this.method = "submitApprovalConfirmation";
    if (msg === "approve") {
      this.msg = "Are you sure you want to approve this initiative?";
    } else {
      this.msg = "Are you sure you want to decline this initiative?";
    }
  }

  submitApprovalConfirmation() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.spinner.show();
    this.approvedAmount = this.hoshinApproveClicked ? this.approvedAmount : 0;
    const approvalData = {
      userId: this.userId,
      hoshinId: this.hoshinId,
      isApproved: this.hoshinApproveClicked,
      approvalAmount: this.approvedAmount,
      comments: this.approveRejectComment,
      type: "individual",
    };

    this.hoshinService.approveorRejectHoshin(approvalData).subscribe((res) => {
      if (res != null && res !== undefined) {
        this.spinner.hide();
        this.totalApprovedBudget = res.totalApprovedBudget;
        if (this.hoshinApproveClicked) {
          this.hoshinApproved = true;
          this.hoshinRejected = false;
        } else {
          this.hoshinApproved = false;
          this.hoshinRejected = true;
        }
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.hoshinApproved = false;
          this.hoshinRejected = false;
          this.getHoshinDetails(this.fiscalYear, this.displayType);
          this.isGoalsSelected = false;
          this.isInitiativesSelected = true;
          this.isAddNewInitiativeSelected = false;
          this.isKpiClicked = false;
        }, 2000);
      }
    });
  }

  declineAll() {
    this.showDeclineAllModal = true;
    this.declineAllComment = '';
  }

  cancelDeclineAll() {
    this.showDeclineAllModal = false;
    this.declineAllComment = '';
  }

  confirmDeclineAll() {
    this.spinner.show();
    const declineAllData = {
      userId: this.userId,
      chapterId: this.chapterId,
      fiscalYear: this.fiscalYear,
      comments: this.declineAllComment,
      type: 'declineAll',
    };

    this.hoshinService.approveorRejectHoshin(declineAllData).subscribe((res) => {
      this.spinner.hide();
      if (res != null && res !== undefined) {
        this.showDeclineAllModal = false;
        this.declineAllComment = '';
        this.hoshinRejected = true;
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.hoshinRejected = false;
          this.getHoshinDetails(this.fiscalYear, this.displayType);
          this.isGoalsSelected = false;
          this.isInitiativesSelected = true;
          this.isAddNewInitiativeSelected = false;
          this.isKpiClicked = false;
        }, 2000);
      }
    });
  }
  /** month year selection
   * @class CreateAndEditHoshinComponent
   * @method onOpenCalendar
   */
  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode("month");
  }
  /** on date change
   * @class CreateAndEditHoshinComponent
   * @method onDateChange
   */
  onDateChange(event, _i) {
    this.selectedMonthYear = event;
    const date = new Date(this.selectedMonthYear);
    const transformdate = this.datepipe.transform(date, "MMMM yyyy");
    this.estimatedTiming = transformdate.toString();
  }
  getBaseHoshin(data, i) {
    this.hoshinBase = data;
    this.isViewClicked = true;
    document
      .getElementById("bsaeHoshin" + i)
      .setAttribute(this.dataTargetConstant, "#bpgBaseModal");
    document
      .getElementById("bsaeHoshin" + i)
      .setAttribute(this.dataToggleConstant, "modal");
  }
  getKpi() {
    this.spinner.show();
    this.kpiList = [];
    this.hoshinService.getKpiDetails(this.businessDrivers).subscribe((data) => {
      this.kpiList = data;
      this.spinner.hide();
    });
  }
  calculateMissingFieldsInReflectionScreen() {
    this.kpiReviewMissingFields = "";
    this.overallReviewMissingFields = "";
    let evaluationError = false;

    for (const h of this.hoshinList) {
      if (h.evaluation !== "" && h.evaluation != null) {
        //do nothing
      } else {
        evaluationError = true;
        break;
      }
    }
    if (evaluationError) {
      this.kpiReviewMissingFields =
        "Evaluation is required for all initiatives.";
    }
    if (
      this.challenges === null ||
      this.challenges === undefined ||
      this.challenges === "" ||
      this.highlights === null ||
      this.highlights === undefined ||
      this.highlights === "" ||
      evaluationError
    ) {
      if (
        this.highlights === null ||
        this.highlights === undefined ||
        this.highlights === ""
      ) {
        if (this.overallReviewMissingFields === "") {
          this.overallReviewMissingFields = "Highlights section is required.";
        }
      }
      if (
        this.challenges === null ||
        this.challenges === undefined ||
        this.challenges === ""
      ) {
        if (this.overallReviewMissingFields === "") {
          this.overallReviewMissingFields = "Challenges section is required.";
        } else {
          this.overallReviewMissingFields += " Challenges section is also required.";
        }
      }
    }
  }
  checkAllMandatoryDetailsFilledForReview(data) {
    this.submitButtonClicked = true;
    this.calculateMissingFieldsInReflectionScreen();
    if (data === "kpiReview") {
      if (this.kpiReviewMissingFields === "") {
        this.updateReview(data);
      }
    } else if (this.overallReviewMissingFields === "") {
      this.updateReview(data);
    }
  }

  updateReview(type) {
    this.submitButtonClicked = false;
    // added for showing overallreview on click of save button
    let isKPIEvaluationCompleted = false;
    this.spinner.show();
    this.errorMsg = "";
    const kpiReveiwList = [];
    this.hoshinList.forEach((initiative) => {
      if (initiative.evaluation != null && initiative.evaluation !== "") {
        this.saveKPIReviewDTO = {
          hoshinId: initiative.hoshinId,
          evaluation: initiative.evaluation,
        };
        kpiReveiwList.push(this.saveKPIReviewDTO);
      }
      if (kpiReveiwList.length === this.hoshinList.length) {
        isKPIEvaluationCompleted = true;
      }
    });
    const reviewData = {
      initiativeList: kpiReveiwList,
      additionalComments: this.additionalAdminComments,
      challenges: (this.challenges || '').trim(),
      highlights: (this.highlights || '').trim(),
      fiscalYear: this.fiscalYear,
      type: "review",
      userId: this.userId,
      chapterId: this.chapterId,
    };
    this.hoshinService.saveHoshinReview(reviewData).subscribe((data) => {
      if (data) {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        if (type === "kpiReview") {
          this.selectOverallReview();
          this.spinner.hide();
        } else if (type === "partialSave") {
          if (isKPIEvaluationCompleted) {
            this.kpiReviewMissingFields = "";
            this.isAddNewInitiative = false;
            this.selectOverallReview();
          } else {
            this.kpiReviewSaved = true;
          }
          this.spinner.hide();
        } else {
          this.reviewSubmittedYear = this.fiscalYear;
          this.getYears("saveReview");
        }
        if (this.kpiReviewSaved) {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.kpiReviewSaved = false;
          }, 2000);
        }
      }
    });
  }
  submitPlanAndReview() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.submitButtonClicked = true;
    this.errorMsg = "";
    this.calculateMissingKpi();
    this.calculateMissingMandatoryFields();
    if (this.initiativeList.length === 0) {
      if (this.errorMsg === "") {
        this.errorMsg = "At least one initiative is required to submit the Annual Plan.";
      } else {
        this.errorMsg += ", Initiatives";
      }
    }

    if (
      this.errorMsg === "" &&
      this.errorMsgForMissingKpi === "" &&
      this.errorMsgForMissingMandatoryFields === ""
    ) {
      document
        .getElementById("submitButton")
        .setAttribute(this.dataToggleConstant, "modal");
      document
        .getElementById("submitButton")
        .setAttribute(this.dataTargetConstant, "#myModal");
      this.method = "ConfirmSubmitPlanAndReview";
      this.msg = "Are you sure you want to submit this Annual Plan?";
    } else {
      this.submitButtonClicked = true;
      document
        .getElementById("submitButton")
        .removeAttribute(this.dataToggleConstant);
      document
        .getElementById("submitButton")
        .removeAttribute(this.dataTargetConstant);
    }
  }
  ConfirmSubmitPlanAndReview() {
    if (this.isNaacViewOnly) {
      return;
    }
    this.spinner.show();
    this.submitButtonClicked = false;
    const submitData = {
      chapterId: this.chapterId,
      userId: this.userId,
      planYear: this.fiscalYear,
      reviewYear: Number(this.fiscalYear) - 1,
      type: "submit",
    };
    this.hoshinService.submitHoshin(submitData).subscribe((res) => {
      if (res != null && res !== undefined) {
        this.spinner.hide();
        this.hoshinSubmitted = true;
        this.hoshinSubmit = true;
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.hoshinSubmit = false;
          if (this.adminId !== "1") {
            this.readOnly = true;
          }

          this.getHoshinDetails(this.fiscalYear, "plan");
        }, 2000);
      }
    });
  }
  calculateMissingKpi() {
    this.errorMsgForMissingKpi = "";
    if (this.initiativeList.length > 0 && this.fiscalYear > 2025) {
      this.initiativeList.map((i) => {
        if (i.selectedKpiList === null || i.selectedKpiList.length < 1) {
          if (this.errorMsgForMissingKpi === "") {
            this.errorMsgForMissingKpi = i.bpgInitiative;
          } else {
            this.errorMsgForMissingKpi += ", " + i.bpgInitiative;
          }
        }
      });
    }
  }
  calculateMissingMandatoryFields() {
    this.errorMsgForMissingMandatoryFields = "";
    if (this.initiativeList.length > 0) {
      this.initiativeList.map((i) => {
        if (i.businessDriversInvalid ||
          (this.fiscalYear <= 2026 &&
          (i.isValid === false ||
            i.actionPlan === "" ||
            i.actionPlan === null)) ||
          (this.fiscalYear > 2026 &&
            (i.isValid === false ||
              i.why === "" ||
              i.why === null ||
              i.what === "" ||
              i.what === null ||
              i.plan === "" ||
              i.plan === null ||
              i.how === "" ||
              i.how === null ||
              i.locationWhere === "" ||
              i.locationWhere === null))
        ) {
          if (this.errorMsgForMissingMandatoryFields === "") {
            this.errorMsgForMissingMandatoryFields = i.bpgInitiative;
          } else {
            this.errorMsgForMissingMandatoryFields += ", " + i.bpgInitiative;
          }
        }
      });
    }
  }
  screenExit() {
    this.msg = "Are you sure you want to leave this page?";
    this.method = "confirmExit";
  }
  confirmExit() {
    this.router.navigate(["/annual-plan-home"]);
  }
  printHoshin() {
    this.printClicked = true;
    const printContents = document.getElementById("printHoshins").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    this.spinner.hide();
    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
    setTimeout(
      function () {
        this.printClicked = false;
      }.bind(this),
      1000
    );
  }

  printReflection() {
    this.spinner.show();
    const planData = {
      userId: this.userId,
      adminId: this.adminId,
      fiscalYear: this.fiscalYear,
      type: "plan",
      siteId: this.siteId,
      bpgId: this.bpgId,
    };
    this.hoshinService.getHoshinForSingleUser(planData).subscribe((res) => {
      if (res && res.currentYearDetails) {
        const planInitiativeList: any[] = res.currentYearDetails["initiativeList"] || [];
        this.hoshinList.forEach((h) => {
          const match = planInitiativeList.find(
            (p) => p.hoshinId === h.hoshinId
          );
          if (match) {
            h.kpiList = match.selectedKpiList || [];
          }
        });
      }
      this.spinner.hide();
      this.printTimestamp = new Date().toLocaleString('en-US', {
        month: '2-digit', day: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
      setTimeout(() => {
        const printContents = document.getElementById("printReflection").innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
      }, 300);
    });
  }

  printInitiatives() {
    if (!this.isInitiativePrintActive) {
      return;
    }
    this.printInitiativeHoshinList = this.hoshinList;
    this.printTimestamp = new Date().toLocaleString('en-US', {
      month: '2-digit', day: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
    setTimeout(() => {
      const printContents = document.getElementById("printInitiatives").innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    }, 300);
  }

  logUserAction() {
    const data = {
      userId: this.userId,
      categoryDescription: "Annual Plan",
    };
    this.bpgCommonService.logUserAction(data).subscribe((_data) => { });
  }

  getRemainingChars(text: string, length = 2000): number {
    return length - (text ? text.length : 0);
  }

  async goToKPIEdit(data) {
    await this.getHoshinDetails(this.fiscalYear, "plan");
    for (const d of this.initiativeList) {
      if (d.hoshinId === data.hoshinId) {
        this.editHoshin(d);
        this.kpiClick();
        this.onKpiDataChange();
        break;
      }
    }
  }

  confirmGoToReflection(year) {
    const reflectionYear = parseInt(year);
    this.gotToPastReflection(reflectionYear);
  }

  gotToPastReflection(fy) {
    this.fy = Number(fy);
    this.getYears();
  }

  goTohoshinHome() {
    this.router.navigate(["/annual-plan-home"]);
  }

  goToPlan(fy) {
    this.getHoshinDetails(fy, "plan");
    this.yearList[1].isActive = true;
    this.yearList[0].isActive = false;
  }

  onKpiDataChange() {
    const missingFieldsSet = new Set<string>();

    this.initiativeListHelper(missingFieldsSet);
    this.selectedKpiListHelper(missingFieldsSet);

    if (missingFieldsSet.size > 0) {
      this.kpiReviewMissingFields = `The following fields are required for this initiative: ${Array.from(
        missingFieldsSet
      ).join(", ")}`;
      this.enableSaveInitiativeButton = false;
    } else {
      this.enableSaveInitiativeButton = true;
    }
  }

  initiativeListHelper(missingFieldsSet) {
    for (const d of this.initiativeList) {
      if (d.hoshinId === this.hoshinId) {
        if (this.isEmpty(d.evaluation)) {
          missingFieldsSet.add("evaluation");
        }
        if (this.isEmpty(d.challenges)) {
          missingFieldsSet.add("challenges");
        }
        if (this.isEmpty(d.highlights)) {
          missingFieldsSet.add("highlights");
        }
      }
    }
  }

  selectedKpiListHelper(missingFieldsSet) {
    for (const h of this.selectedKpiList) {
      if (this.isEmpty(h.kpiComments)) {
        missingFieldsSet.add("comments");
      }
      if (this.isEmpty(h.kpiAchievedCount)) {
        missingFieldsSet.add("achieved count");
      }
    }
  }

  isEmpty(value: any): boolean {
    return (
      value === "" || value === null || value === "null" || value === undefined
    );
  }

  goToReflectionNow() {
    if (this.autoRedirectTimeout) {
      clearTimeout(this.autoRedirectTimeout);
      this.autoRedirectTimeout = null;
    }
    this.showReflectionPopup = false;
    this.confirmGoToReflection(this.pendingReflectionYear);
  }

  get filteredUserListForLead1() {
    if (!this.userList || this.userList.length === 0) {
      return [];
    }
    if (!this.leadId2) {
      return this.userList;
    }
    return this.userList.filter(user => user.userId !== this.leadId2);
  }

  get filteredUserListForLead2() {
    if (!this.userList || this.userList.length === 0) {
      return [];
    }
    if (!this.leadId1) {
      return this.userList;
    }
    return this.userList.filter(user => user.userId !== this.leadId1);
  }

    getLeadDisplayName(userId: any): string {
    if (this.isEmpty(userId) || !this.userList || this.userList.length === 0) {
      return "";
    }

    const user = this.userList.find((u) => String(u.userId) === String(userId));
    return user ? user.userFirstName : "";
  }

  get isInitiativePrintActive(): boolean {
    const s = this.overallStatus;
    return (
      s === "SUBMITTED" ||
      s === "APPROVED" ||
      s === "REJECTED"
    );
  }

  get refMsgActive() {
    if (this.overallStatus === 'APPROVED') {
      return false;
    }
    return true;
  }

  get isInitiativeFormDisabled(): boolean {
    return (
      this.overallStatus === "SUBMITTED" ||
      this.isNaacViewOnly ||
      (this.overallStatus === "REJECTED" &&
        (this.adminId === "4" || this.isNaacAdmin)) ||
      (this.overallStatus === "APPROVED" && this.adminId !== "1") ||
      (this.isSuperAdminApproved && this.adminId !== "1")
    );
  }

  private isNaacUser(): boolean {
    const id = String(this.adminId || "");
    return (
      this.isNaacAdmin ||
      id === "4" ||
      id.split(",").map((s) => s.trim()).includes("4")
    );
  }
}
